<template>
    <div class="sui-swiper"
        @touchstart="touchstartEvent"
        @touchmove.passive="touchmoveEvent"
        @touchend="touchendEvent">
        <ul
            :style="styleUl">
            <li
                v-if="infinite"
                :style="styleLi">
                <slot :item="list[list.length - 1]"></slot>
            </li>
            <li
                v-for="(item) in list"
                :key="item[keyName]"
                :style="styleLi">
                <slot :item="item"></slot>
            </li>
            <li
                v-if="infinite"
                :style="styleLi">
                <slot :item="list[0]"></slot>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'sui-swiper',

    props: {
        list: {
            type: Array,
            required: true
        },

        infinite: {
            type: Boolean,
            default: true
        },

        keyName: {
            type: String,
            required: true
        },

        index: {
            type: Number,
            default: 0
        }
    },

    data() {
        let currentIndex = this.infinite ? this.index + 1 : this.index
        return {
            currentIndex,
            originX: 0, // 触摸起始位置 X 坐标
            threshold: 20, // 偏移量少于该值，不进行翻页
            translateX: `-${ currentIndex * 100 / this.list.length }%`,
            transition: '', // 动画参数
            timer: 0,
        }
    },

    computed: {
        styleUl() {
            return {
                'width': `${ this.list.length * 100 }%`,
                'transform': `translate3d(${ this.translateX }, 0, 0)`,
                'transition': this.transition,
            }
        },

        styleLi() {
            return {
                'width': `${ 100 / this.list.length }%`,
            }
        },
    },

    methods: {

        /**
         * touchstart 事件
         * @param {Object} event - 事件对象
         */
        touchstartEvent(event) {
            clearTimeout(this.timer)
            this.restore()
            const touch = event.targetTouches[0]
            this.originX = touch.clientX
        },

        /**
         * touchmove 事件
         * @param {Object} event - 事件对象
         */
        touchmoveEvent(event) {
            const touch = event.targetTouches[0]
            const offsetX = touch.clientX - this.originX
            this.translateX = `${ offsetX - this.currentIndex * this.$el.getBoundingClientRect().width }px`
        },

        /**
         * touchend 事件
         * @param {Object} event - 事件对象
         */
        touchendEvent(event) {
            const touch = event.changedTouches[0]
            const offsetX = touch.clientX - this.originX
            if (Math.abs(offsetX) > this.threshold) {
                if (offsetX > 0) {
                    
                    /* #region 上一页 */
                    this.currentIndex -= 1
                    if (this.currentIndex < 0 && !this.infinite) {
                        this.currentIndex = 0
                    }
                    /* #endregion */

                } else {
                    
                    /* #region 下一页 */
                    this.currentIndex += 1
                    if (this.currentIndex > this.list.length -1 && !this.infinite) {
                        this.currentIndex = this.list.length -1
                    }
                    /* #endregion */

                }
            }

            /* #region 动画执行 */
            const time = 500
            this.transition = `transform ${ time }ms`
            this.translateX = `-${ this.currentIndex * this.$el.getBoundingClientRect().width }px`
            this.timer = setTimeout(this.restore.bind(this), time)
            /* #endregion */

        },

        /**
         * 首尾拼接
         */
        restore() {
            this.transition = ''
            if (this.infinite) {
                if (this.currentIndex == 0) {
                    this.currentIndex = this.list.length
                }
                if (this.currentIndex == this.list.length + 1) {
                    this.currentIndex = 1
                }
            }
            this.translateX = `-${ this.currentIndex * this.$el.getBoundingClientRect().width }px`
            this.$emit('change', this.infinite ? this.currentIndex - 1 : this.currentIndex)
        },
    }
}
</script>

<style lang="postcss">
.sui-swiper {
    overflow: hidden;
    width: 100%;
    height: 100%;
    ul {
        display: flex;
        height: 100%;
        margin: 0;
        padding: 0;
        li {
            flex: none;
            height: 100%;
            list-style-type: none;
        }
    }
}
</style>
